import { readFragment, FragmentOf } from "gql.tada";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";

export const CaseStudyIconGrid = ({
  data,
}: {
  data: FragmentOf<typeof IconGridFragment> | null | undefined;
}) => {
  if (!data) return null;
  const grid = readFragment(IconGridFragment, data);
  const items =
    grid.iconsCollection?.items.filter((icon) => icon?.asset?.url) ?? [];
  if (items.length === 0) return null;

  return (
    <section className="case-study-icon-grid py-[120px] px-6 dsk:px-[90px] flex items-center justify-center">
      <div className="w-full max-w-[923px] flex flex-col items-center">
        <ul className="flex flex-wrap items-center justify-center gap-x-[30px] gap-y-8 w-full">
          {items.map(
            (icon) =>
              icon?.asset?.url && (
                <li
                  key={icon._id}
                  className="flex items-center justify-center"
                >
                  <img
                    src={icon.asset.url}
                    alt={icon.name ?? ""}
                    className="h-[50px] dsk:h-[60px] w-auto max-w-[180px] object-contain"
                  />
                </li>
              )
          )}
        </ul>
      </div>
    </section>
  );
};
